import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import RegionsItemForm from "./RegionsItemForm";
import RegionsItemBrowser from "./RegionsItemBrowser";

const RegionsSubPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="region"
            modeApiName2="regions"
            ItemFormComponent={RegionsItemForm}
            ItemBrowserComponent={RegionsItemBrowser}
        />
    );
};

export default RegionsSubPage;